import { Moment } from 'moment';
import * as moment from 'moment';

export class LocalNote {

  public id: string;
  public createdAt: Moment;
  public createdBy: string;
  public subject: string;
  public message: string;
  public replies: LocalNote[] = [];
  public isPicture            = false;
  public pictureUrl: string;
  public pictureShowed        = false;

  static fromDto(data: any): LocalNote {
    if (!data) {
      return null;
    }

    const note = new LocalNote();

    note.id        = data.id;
    note.createdAt = data.created_at ? moment(data.created_at) : null;
    note.createdBy = data.created_by;
    note.subject   = data.subject;
    note.message   = data.message;

    if (data.replies) {
      note.replies = data.replies.map(n => this.fromDto(n));
    }

    return note;
  }

  showPicture() {
    this.pictureShowed = !this.pictureShowed;
  }
}
